import DiceModule from 'react-dice-roll';

import { type TaskResponse } from '../../client';
import { useThrowDiceMiniGame } from '../../hooks';

import { Progress } from '../atoms';
import { TaskCard } from './TaskCard';

// react-dice-roll ships only CJS with `__esModule` + `exports.default`. Since
// vite 8 (Node-consistent CJS interop, this package is `"type": "module"`) the
// default import is `module.exports` itself, so the component sits one level
// down; other toolchains still hand over the component directly.
const Dice = (DiceModule as unknown as { default?: typeof DiceModule }).default ?? DiceModule;

interface Props {
  task: TaskResponse;
  onTaskStarted: (task: TaskResponse) => Promise<void>;
  onTaskProgress: (task: TaskResponse, progress: number) => void;
  onTaskCompleted: (task: TaskResponse) => Promise<void>;
}

export function TaskCardDice({ task, onTaskStarted, onTaskProgress, onTaskCompleted }: Props) {
  const { rollingTime, handleThrow, remainingScore, progressPercentage } = useThrowDiceMiniGame(
    task,
    onTaskStarted,
    onTaskProgress,
    onTaskCompleted,
  );

  return (
    <TaskCard task={task}>
      <p className="text-center text-2xl">
        Remaining score:&nbsp;
        <b>{remainingScore}</b>
      </p>
      <Progress size="sm" value={progressPercentage} />

      <div className="flex justify-center items-center py-5 rounded-lg bg-bg-elevated mt-2">
        <Dice size={100} faceBg={'white'} rollingTime={rollingTime} onRoll={handleThrow} />
      </div>
    </TaskCard>
  );
}
